import { isToday } from 'date-fns';

function removeTimeFromDate(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

function getScheduleDurationInHours(schedule) {
  return Number(schedule?.to) - Number(schedule?.from);
}

function getScheduleDurationInDays(startDate, endDate) {
  if (!endDate) return 0;

  const startDateOnly = removeTimeFromDate(startDate);
  const endDateOnly = removeTimeFromDate(endDate);

  // Calculate difference in days
  const msPerDay = 1000 * 60 * 60 * 24;
  const diffInMs = endDateOnly - startDateOnly;
  return diffInMs / msPerDay;
}

export const mapDataForBackend = (data) => {
  const date = new Date(data?.date);
  const hours = date.getHours();
  const minutes = date.getMinutes();

  if (isToday(date) && data?.scheduleType === 'daily') {
    date.setHours(hours);
    date.setUTCMinutes(minutes + 2);
    date.setUTCSeconds(0);
  } else {
    date.setHours(data?.from);
    date.setUTCMinutes(0);
    date.setUTCSeconds(0);
  }

  return {
    date: date?.toISOString(),
    confirmed: true,
    resourceId: data?.resourceId,
    duration: {
      ...(data?.scheduleType === 'slots' && {
        hours: getScheduleDurationInHours(data),
      }),
      ...(data?.scheduleType === 'daily' && {
        days: getScheduleDurationInDays(data?.date, data?.endDate),
      }),
    },
  };
};
